import { render, staticRenderFns } from "./ClusterLevel.vue?vue&type=template&id=9f1dbcc2&scoped=true"
import script from "./ClusterLevel.vue?vue&type=script&lang=js"
export * from "./ClusterLevel.vue?vue&type=script&lang=js"
import style0 from "./ClusterLevel.vue?vue&type=style&index=0&id=9f1dbcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1dbcc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
